import { defineStore } from 'pinia';
import { ElLoading, ElNotification, ElMessage } from 'element-plus';

// eslint-disable-next-line import/prefer-default-export
export const mainStore = defineStore(('mainStore'), {
  state: () => ({
    // mensagem
    messages: [],
    // informa se o form corrente e do tipo dialogo
    formCurDialog: false,
    fetching: false,
    // cabecalho da rota atual
    headerCurRouter: '',
    // menu lateral da rota atual
    leftCurRouter: '',
    // indica se o servico de loading sera ativado na solicitacao http
    serviceLoading: true,
    // contador de requisicoes aguardando resposta
    loading: 0,
    // indica se o comportamento do Loading esta ativado
    isLoading: false,
  }),
  actions: {
    setFetching(obj) {
      this.fetching = obj;
    },

    setMessage(obj) {
      let distancia = 20;
      for (let index = 0; index < obj.length; index += 1) {
        if (obj[index].title) {
          ElNotification({
            title: obj[index].title,
            message: obj[index].value,
            type: obj[index].type.toLowerCase(),
            duration: 0,
            offset: 20,
            customClass: 'custom-message',
          });
        } else {
          ElMessage({
            showClose: true,
            type: obj[index].type.toLowerCase(),
            message: obj[index].value,
            offset: distancia,
            duration: 6000,
            customClass: 'custom-message',
          });
          distancia += 50;
        }
      }
      this.messages.push(obj);
    },

    resetMessages() {
      this.messages = [];
    },

    removeMessage(index) {
      this.messages.splice(index, 1);
    },

    setCurRoute(paths) {
      this.headerCurRouter = paths.header;
      this.leftCurRouter = paths.left;
    },

    setServiceLoading(value) {
      this.serviceLoading = value;
    },

    startLoading() {
      if (this.loading >= 0 && this.serviceLoading) {
        ElLoading.service({ fullscreen: true });
        this.isLoading = true;
      }
      this.loading += 1;
      this.serviceLoading = true;
    },

    finishLoading() {
      this.loading -= 1;
      if (this.loading === 0 && this.isLoading) {
        ElLoading.service().close();
        this.isLoading = false;
      }
    },
  },
});
